import React from 'react';
import { Card, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const AuthStatus: React.FC = () => {
  const navigate = useNavigate();
  const user = localStorage.getItem('user');
  const isLoggedIn = user !== null;
  
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };
  
  const goLogin = () => {
    navigate('/login');
  };
  
  return (
    <Card title="认证状态调试" style={{ maxWidth: 300, margin: '10px' }}>
      <p>当前状态: {isLoggedIn ? '已登录' : '未登录'}</p>
      <p>用户信息: {isLoggedIn ? user : '无'}</p>
      <div>
        {isLoggedIn ? (
          <Button onClick={handleLogout} danger>登出</Button>
        ) : (
          <Button onClick={goLogin} type="primary">去登录</Button>
        )}
      </div>
    </Card>
  );
};

export default AuthStatus;
